// En MenuPage.jsx
import React, { useState } from 'react';
import CategorySelector from '../components/Menu/CategorySelector';
import ProductGrid from '../components/Menu/ProductGrid';
import './MenuPage.css';

const MenuPage = ({ category: initialCategory = 'coffee', onBack, onProductSelect }) => {
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);

  const categories = [
    { id: 'coffee', name: 'Coffee' },
    { id: 'smoothies', name: 'Smoothies' },
    { id: 'bakery', name: 'Bakery' },
    { id: 'salads', name: 'Salads' }
  ];

  return (
    <div className="menu-page">
      <CategorySelector 
        categories={categories}
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />
      
      <ProductGrid 
        category={selectedCategory} 
        onBack={onBack}
        onProductSelect={onProductSelect}
      />
    </div>
  );
};

export default MenuPage;